import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { SliderService, SliderOutputDto } from 'src/generated_client';

@Component({
  selector: 'app-start-slider',
  templateUrl: './start-slider.component.html',
  styleUrls: ['./start-slider.component.css']
})

export class StartSliderComponent implements OnInit {

  displayedColumns: string[] = ['imagen', 'orden', 'titulo', 'opcion'];
  allSliders: SliderOutputDto[] = [];

  constructor(
    private router: Router,
    private sliderService: SliderService,
    private snackBar: SnackBarService
  ) { }

  ngOnInit(): void {

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.sliderService.apiSliderGetAllGet().subscribe(x => {
      this.allSliders = x;
      this.allSliders.sort((a, b) => (a.nmSortNo! > b.nmSortNo!) ? 1 : -1);
    });
  }

  addSlider() {
    this.router.navigate(['add-slider']);
  }

  editSlider(id: number) {
    this.router.navigate(['edit-slider', id]);
  }

  deleteSlider(id: number) {

    this.sliderService.apiSliderDeleteDelete(id).subscribe(() => {

      this.router.navigate(['start-slider'])
      this.snackBar.openSnackBar('El slider fue eliminado', 'Aceptar')
    },
      err => {

        this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron guardarse.', 'Aceptar')
      }
    )
  }
}

